import { fieldSearch } from '@openx/utils/lib/clientSideCriteriaProcessing';

interface FilterBase {
  account?: {
    name: string;
  };
  is_active?: boolean;
  role?: string;
}

type SearchFiltersValue<T> = {
  fields?: (keyof T)[];
  phrase?: string;
  account?: string;
  status?: string;
  role?: string;
};

export function applyCustomFilter<ItemT extends FilterBase>(
  items: ItemT[],
  search: SearchFiltersValue<ItemT>
): ItemT[] {
  const { fields, phrase, account, status, role } = search;

  if (!phrase && !account && !status && !role) {
    return items;
  }

  return items.filter((item: ItemT) => {
    if (phrase && fields) {
      const matchesPhrase = fields.some(fieldKey => fieldSearch(item[fieldKey], phrase));
      if (!matchesPhrase) {
        return false;
      }
    }

    if (account) {
      const matchesAccount = item.account?.name === account;
      if (!matchesAccount) {
        return false;
      }
    }

    if (status) {
      const matchesStatus = item.is_active === JSON.parse(status);
      if (!matchesStatus) {
        return false;
      }
    }

    if (role) {
      const matchesRoles = item.role === role;
      if (!matchesRoles) {
        return false;
      }
    }

    return true;
  });
}
